import Phaser from 'phaser';

interface ResultData {
  win: boolean;
  credits: number;
  completed: number;
  reputation: number;
}

export class ResultScene extends Phaser.Scene {
  private dataReceived!: ResultData;

  constructor() {
    super({ key: 'ResultScene' });
  }

  init(data: ResultData): void {
    this.dataReceived = data;
  }

  create(): void {
    const { win, credits, completed, reputation } = this.dataReceived;

    // Background overlay
    this.add.rectangle(480, 320, 960, 640, 0x000000, 0.85);

    // Panel
    const panel = this.add.image(480, 320, 'spr_panel').setScale(0.8);

    // Title
    const title = win ? 'CHIẾN THẮNG!' : 'HẾT GIỜ!';
    const titleColor = win ? '#00ff00' : '#ff4444';
    this.add.text(480, 200, title, {
      fontSize: '40px', color: titleColor, fontStyle: 'bold',
      stroke: '#000000', strokeThickness: 4,
    }).setOrigin(0.5);

    // Stats
    this.add.text(480, 280, `Tổng Credits: $${credits}`, {
      fontSize: '24px', color: '#ffd700', fontStyle: 'bold',
      stroke: '#000000', strokeThickness: 3,
    }).setOrigin(0.5);

    this.add.text(480, 330, `Đơn hoàn thành: ${completed}`, {
      fontSize: '24px', color: '#ffffff', fontStyle: 'bold',
      stroke: '#000000', strokeThickness: 3,
    }).setOrigin(0.5);

    this.add.text(480, 380, `Reputation: ${reputation}/100`, {
      fontSize: '24px', color: '#ffffff', fontStyle: 'bold',
      stroke: '#000000', strokeThickness: 3,
    }).setOrigin(0.5);

    // Restart button
    const btnBg = this.add.rectangle(480, 460, 200, 50, 0x44aa44, 0.95)
      .setStrokeStyle(3, 0xffffff)
      .setInteractive({ useHandCursor: true });
    const btnText = this.add.text(480, 460, 'CHƠI LẠI', {
      fontSize: '22px', color: '#ffffff', fontStyle: 'bold',
    }).setOrigin(0.5);

    btnBg.on('pointerdown', () => {
      this.scene.start('GameScene');
    });

    // Hover effects
    btnBg.on('pointerover', () => btnBg.setFillStyle(0x55cc55));
    btnBg.on('pointerout', () => btnBg.setFillStyle(0x44aa44));
  }
}
